<template>
    <div class="row">  
      <div class="col-12">
        <div class="row">
          <div class="col-8">
            <Breadcrumb :page="page" />
          </div>
          <div class="col-4 mt-5 text-right ">
            <div class="col-12 mx-0">
              
                <ActionButton
                  variant="outline-success mr-2"
                  i="fas fa-arrow-circle-left"
                  @click="back"
                >
                  {{ field.btnReturn.text }}
                </ActionButton>

              <ActionButton
                :class="!field.btnSave.isEnabled ? 'disabled-page' : ''"
                :disabled="!field.btnSave.isEnabled"
                variant="success mr-2"
                i="fas fa-save"
                @click="handleSubmit"
              >
                {{ field.btnSave.text }}
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
      <ValidationObserver
        ref="formObserver"
        tag="form"
        novalidate
      >
        <div class="row">
          <div class="col-12">
            <div class="dropdown-divider pb-2 mx-4" />
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <SectionTitle content="Información General" />
              </div>
            </div>
            <div class="dropdown-divider w-100 my-0" />
            <div class="row mx-1 pt-1">
              <div class="col-2 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="
                    field.datePickerDateEvaluation.isRequired ? 'required' : ''
                  "
                >
                  <CustomDatePicker
                    v-model="field.datePickerDateEvaluation.selected"
                    :disabled="field.datePickerDateEvaluation.disabled"
                    :label="field.datePickerDateEvaluation.label"
                    :error="errors[0]"
                    :custom-error-msg="field.datePickerDateEvaluation.errorMsg"
                    :max-date="field.datePickerDateEvaluation.maxDate"
                    class="custom-datetime-picker-container custom-datetime-picker-container-grey"
                  />
                </ValidationProvider>
              </div>
              <div class="col-2 pt-1" />
              <div class="col-3 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="dropDownEvaluation"
                  mode="eager"
                  :rules="
                    `${field.dropDownEvaluation.isRequired ? 'required' : ''}`
                  "
                >
                  <CustomDropDown
                    :id="field.dropDownEvaluation.id"
                    v-model="field.dropDownEvaluation.selected"
                    :disabled="true"
                    :label="field.dropDownEvaluation.label"
                    :custom-error-msg="field.dropDownEvaluation.errorMsg"
                    :error="errors[0]"
                    :placeholder="field.dropDownEvaluation.placeHolder"
                    :fieldkey="field.dropDownEvaluation.fieldkey"
                    :fieldname="field.dropDownEvaluation.fieldname"
                    :options="field.dropDownEvaluation.items"
                    @input="getDisciplines"
                  />
                </ValidationProvider>
              </div>
              <div class="col-2 pt-1" />
              <div class="col-3 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="dropDownDiscipline"
                  mode="eager"
                  :rules="
                    `${field.dropDownDiscipline.isRequired ? 'required' : ''}`
                  "
                >
                  <CustomDropDown
                    :id="field.dropDownDiscipline.id"
                    v-model="field.dropDownDiscipline.selected"
                    :disabled="field.dropDownDiscipline.disabled"
                    :label="field.dropDownDiscipline.label"
                    :custom-error-msg="field.dropDownDiscipline.errorMsg"
                    :error="errors[0]"
                    :placeholder="field.dropDownDiscipline.placeHolder"
                    :fieldkey="field.dropDownDiscipline.fieldkey"
                    :fieldname="field.dropDownDiscipline.fieldname"
                    :options="field.dropDownDiscipline.items"
                    @input="onChangeDiscipline()"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <SectionTitle content="Razón" />
              </div>
            </div>
            <div class="dropdown-divider w-100 mt-0 pb-1" />
            <div class="row mt-1">
              <div class="col-12">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="field.textAreaReason.isRequired ? 'required' : ''"
                >
                  <CustomTextArea
                    v-show="field.textAreaReason.isVisible"
                    v-model="field.textAreaReason.model"
                    :disabled="field.textAreaReason.disabled"
                    :maxlength="field.textAreaReason.maxlength"
                    :rows="field.textAreaReason.rows"
                    :placeholder="field.textAreaReason.placeHolder"
                    :error="errors[0]"
                    :custom-error-msg="field.textAreaReason.errorMsg"
                  />
                </ValidationProvider>
              </div>
            </div>
  
            <div class="row">
              <div class="col-12 px-1 pr-3">
                <WarningBox
                  title="Si desea hacer una evaluación Trianual, debe hacerse por la Pantalla Proceso de Evaluación Trianual o Cambio de Impedimento."
                />
              </div>
            </div>
          </div>  
        </div>
        <div v-if="!isAdaptedPhysicalEducationSelected" class="row mx-2 mt-4">
          <div class="col-12">
            <div slot="header">
              <div class="tag-badge pl-2">
                <span class="dot text-center">
                  <i
                    class="far fa-check-circle orange-icon orange-icon-badge-align"
                  />
                </span>
                <span class="tag-badge-title py-1 pl-2">
                  Términos y Responsabilidades
                </span>
              </div>
            </div>
            <div class="row mx-1">
              <div class="col-12 px-0">
                <div class="border-box">
                  Certifico por este medio, que este referido podrá encontrarse en
                  el expediente físico del estudiante firmado por todas las partes
                  involucradas. (0502)
                </div>
              </div>
            </div>
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              name="checkboxConditions"
              :rules="field.checkboxConditions.isRequired ? 'required' : ''"
            >
              <div class="row mx-1">
                <div
                  class="border-box gray"
                  :class="{ error: errors.length > 0 }"
                >
                  <div class="col-12 px-0 py-0">
                    <div class="custom-control custom-checkbox">
                      <div class="custom-control custom-checkbox">
                        <input
                          id="checkboxConditions"
                          v-model="field.checkboxConditions.selected"
                          :disabled="field.checkboxConditions.disabled"
                          type="checkbox"
                          class="custom-control-input"
                          name="checkboxConditions"
                          @change="checkboxConditionsChange()"
                        />
                        <label
                          class="custom-control-label pl-3"
                          for="checkboxConditions"
                        >
                          Acepto los términos y responsabilidades
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="errors.length > 0" class="row mt-1">
                  <div class="col-12">
                    <i class="fa fa-times-circle text-red pr-2" />
                    <span class="invalid">
                      {{ field.checkboxConditions.errorMsg }}
                    </span>
                  </div>
                </div>
              </div>
            </ValidationProvider>
          </div>
        </div>
      </ValidationObserver>
      <custom-contact-info-modal
        ref="contactInfoModalRef"
        @cancel="cancelContactInfoModal"
        @save="saveContactInfoModal"
      />
    </div>
  </template>
  
  <script>
  import store from '@/store/index';
  import loading from '@/mixin/loading.mixin';
  import alert from '@/mixin/alert.mixin';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import Breadcrumb from '@/components/common/page/TitleBreadcrumb';
  import WarningBox from '@/components/pei/service/components/ServiceWarningBox';
  import disciplineCategories from '@/utils/constants/student/disciplineCategories';
  import { SectionTitle } from '@/components/pei/shared';
  import {
    CustomDatePicker,
    ActionButton,
    CustomDropDown,
    CustomTextArea,
  } from '@/components/common';
  import CustomContactInfoModal from '@/components/common/CustomContactInfoModal';
  import StudentMedicalInfo from '@/views/student/AdditionalEvaluations/components/StudentMedicalInfo.vue';
  import StudentInterventionLevel from '@/views/student/AdditionalEvaluations/components/StudentInterventionLevel.vue';
  import disciplines from '@/utils/constants/disciplineTypes.js';
  import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
  import appointmentServiceManager from '@/services/api/appointment.api.js';
  import objectToFormData from 'object-to-formdata';
  import StudentAlternatePlacement from '@/views/student/AdditionalEvaluations/components/StudentAlternatePlacement.vue';
  import documentTypes from '@/utils/constants/documentTypes';
  import alternatePlacementsTypes from '@/utils/constants/alternatePlacements';
  import studentEvaluationServices from "@/modules/student-evaluation-request-managment/api.js"
  export default {
    mixins: [loading, alert],
    components: {
      Breadcrumb,
      ActionButton,
      CustomTextArea,
      ValidationObserver,
      CustomDropDown,
      CustomDatePicker,
      WarningBox,
      ValidationProvider,
      SectionTitle,
      CustomContactInfoModal,
      StudentMedicalInfo,
      CustomCheckboxSingleOption,
      StudentInterventionLevel,
      StudentAlternatePlacement,
    },
    data() {
      return {
        disciplines,
        name: 'DetailEditEvaluations',
        page: {
          icon: 'fas fa-user-edit',
          title: 'Añadir Referido a Evaluación',
          routes: [
            'Inicio',
            'Estudiante',
            'Solicitud de Evaluación Adicional/Añadir Referido a Evaluación',
          ],
        },
        studentSie: store.getters['$_student/StudentSie'],
        ValidationTriggered: store.getters.getatValidationTriggered,
        apiUrl: '/api/studentEvaluation',
        field: {
          datePickerDateEvaluation: {
            isRequired: true,
            disabled: false,
            label: 'Fecha',
            maxDate: new Date(),
            errorMsg: 'Favor de seleccionar una fecha para la solicitud.',
            selected: new Date(),
          },
          dropDownEvaluation: {
            isRequired: true,
            disabled: false,
            label: 'Evaluación',
            id: 'dropDownEvaluation',
            placeHolder: 'Seleccione',
            fieldkey: 'evaluationTypeId',
            fieldname: 'description',
            errorMsg: 'Favor de seleccionar un tipo de evaluación.',
            items: [],
            selected: null,
          },
          dropDownDiscipline: {
            isRequired: true,
            disabled: true,
            label: 'Disciplina',
            id: 'dropDownDiscipline',
            placeHolder: 'Seleccione',
            fieldkey: 'id',
            fieldname: 'disciplineName',
            errorMsg: 'Favor de seleccionar una disciplina.',
            items: [],
            selected: null,
          },
          textAreaReason: {
            isRequired: true,
            disabled: false,
            isVisible: true,
            maxlength: 3000,
            rows: 5,
            placeHolder: 'Escribir comentario...',
            errorMsg:
              'Favor de escribir una razón para solicitar esta evaluación.',
            model: null,
          },
          checkboxConditions: {
            isRequired: true,
            disabled: false,
            selected: null,
            errorMsg:
              'Debe aceptar los términos y responsabilidades para poder continuar. (0229)',
          },
          btnSave: {
            isEnabled: true,
            text: 'Guardar',
          },
          btnReturn: {
            text: 'Regresar',
          },
          medicalInformation: {
            disabled: false,
          },
          interventionLevel: {
            disabled: false,
          },
          alternatePlacement: {
            disabled: false,
          },
        },
        medicalInfo: {
          healthCondition: null,
          surgicalIntervention: null,
          surgicalInterventionDate: null,
          medicationSchoolHours: null,
          explainMedication: null,
          allergy: null,
          equipments: [],
        },
        interventionLevelInfo: {},
        alternatePlacementInfo: {
          alternatePlacement: {},
          documents: [],
        },
        documentErrors: [],
        infoParam: null
      };
    },
    computed: {
      isAdaptedPhysicalEducationSelected() {
        return (
          this.field.dropDownDiscipline.selected?.id == disciplines.FisicaAdaptada
        );
      },
      isUserPilotPlan() {
        return store.getters['$_user/pilotPlan'];
      },
      isVocationalEducationSelected() {
        return (
          this.field.dropDownDiscipline.selected?.id ==
          disciplines.EducacionVocacional
          || this.field.dropDownDiscipline.selected?.id ==
          disciplines.EvaluacionVocacionalPreliminar
          || this.field.dropDownDiscipline.selected?.id ==
          disciplines.EvaluacionVocacionalFinal
        );
      },
      isEFASelected() {
        return (
          this.field.dropDownDiscipline.selected?.id == disciplines.FisicaAdaptada
        );
      },
    },
    methods: {
      validateEFA04() {
        let emptyError = '';
        const isRequiredEFA04 = this.field.dropDownDiscipline.selected?.id == disciplines.FisicaAdaptada;
  
        if (!isRequiredEFA04) return emptyError;
  
        const isValid = this.alternatePlacementInfo.documents
          .filter(doc => doc.documentTypeId == documentTypes.SAEE_EFA4)
          .length > 0;
  
        if (isValid) return emptyError;
        
        return 'El documento de SAEE (EFA-04) es requerido.';
      },
      back(){
        this.$router.go(-1);
      },
      validateEFA03() {
        let emptyError = '';
        const isRequiredEFA03 = this.field.dropDownDiscipline.selected?.id == disciplines.FisicaAdaptada
        && [
          alternatePlacementsTypes.SalonEspecialEnEscuelaRegular,
          alternatePlacementsTypes.SalonRegularConServiciosDeSalonRecurso,
          alternatePlacementsTypes.SalonRegularConServiciosRelacionados,
          alternatePlacementsTypes.SalonRegularConServiciosYAyudaSuplementaria,
          alternatePlacementsTypes.SalonRegularConServiciosSuplementarios
        ].includes(this.alternatePlacementInfo.alternatePlacement?.id);
  
        if (!isRequiredEFA03) return emptyError;
  
        const isValid = this.alternatePlacementInfo.documents
          .filter(doc => doc.documentTypeId == documentTypes.SAEE_EFA3)
          .length > 0;
  
        if (isValid) return emptyError;
        
        return 'El documento de SAEE (EFA-03) es requerido.';
      },
      validateDocuments() {
        this.documentErrors = [];
        const errorMessageEFA03 = this.validateEFA03();
        const errorMessageEFA04 = this.validateEFA04();
  
        if (!!errorMessageEFA03) this.documentErrors.push(errorMessageEFA03);
        if (!!errorMessageEFA04) this.documentErrors.push(errorMessageEFA04);
  
        return this.documentErrors.length == 0;
      },
      disableFields(disable = true) {
        this.field.datePickerDateEvaluation.disabled = disable;
        this.field.dropDownEvaluation.disabled = disable;
        this.field.dropDownDiscipline.disabled = disable;
        this.field.textAreaReason.disabled = disable;
        this.field.checkboxConditions.disabled = disable;
        this.field.btnSave.isEnabled = !disable;
        if (this.isAdaptedPhysicalEducationSelected) {
          this.field.medicalInformation.disabled = disable;
        }
      },
      checkboxConditionsChange() {
        if (!this.field.checkboxConditions.selected) {
          this.field.checkboxConditions.selected = null;
        }
      },
      async getEvaluations() {
        this.$ApiGet(`${this.apiUrl}/EvaluationTypes/${true}`).then(
          (res) =>
            (this.field.dropDownEvaluation.items = res.data ? res.data : [])
        );
      },
      async getDisciplines() {
        this.field.dropDownDiscipline.selected = null;
  
        if (this.field.dropDownEvaluation.selected) {
          this.$ApiGet(
            `${this.apiUrl}/${this.studentSie}/validDisciplineTypes/${this.field.dropDownEvaluation.selected.evaluationTypeId}/${disciplineCategories.ValidForAppointment}`
          ).then((res) => {
            this.field.dropDownDiscipline.items = res.data ? res.data : [];
            this.field.dropDownDiscipline.disabled = false;
          });
        } else {
          this.field.dropDownDiscipline.disabled = true;
          this.field.dropDownDiscipline.items = [];
        }
      },
      async handleSubmit(e) {
        if (!this.field.btnSave.isEnabled) return;
        
        const isValid = await this.$refs.formObserver.validate();
  
        if (!isValid ) {
          this.ShowToast(
            'Información Incompleta',
            'Favor de completar la información requerida.',
            'error'
          );
  
          return;
        }
        await this.saveContactInfoModal();
      },
      async saveContactInfoModal() {
        let dataTosend = {
            studentReferralId: parseInt(this.infoParam.studentReferralId),
            referralRequestReason: this.field.textAreaReason.model
        };
        await studentEvaluationServices.updateReferralStatusReason(dataTosend);
        this.ShowToast(
          "Proceso exitoso.",
          "Su información ha sido guardada.",
          "success"
        );
        this.back()
      },
      loadElementFromParam(){
        this.field.dropDownEvaluation.selected = {
            evaluationTypeId:this.infoParam.evaluationTypeId,
            description:this.infoParam.evaluationTypeName
        };
        this.field.dropDownDiscipline.selected = {
            id:this.infoParam.disciplineTypeId,
            disciplineName:this.infoParam.disciplineTypeName
        };
        this.field.textAreaReason.model = this.infoParam.referralRequestReason
      }
    },
    watch: {
      'alternatePlacementInfo.documents'() {
        this.documentErrors = [];
      }
    },
    async mounted() {
        this.infoParam = this.$route.query;
        this.studentSie = this.infoParam.studentSieId;
        await this.getEvaluations();
        this.loadElementFromParam()
    },
  };
  </script>
  
  <style scope>
  form {
    width: 100%;
  }
  </style>
  <style src="@/assets/css/component/radio-button.css"></style>
  <style src="@/assets/css/component/datepicker.css"></style>
  <style src="@/assets/css/component/badge.css"></style>
  <style src="@/assets/css/component/textarea.css"></style>
  <style src="@/assets/css/component/messages.css"></style>
  
  <style scoped>
  .disabled-page {
    pointer-events: none;
  }
  
  .wrapper-block {
    cursor: not-allowed !important;
  }
  .global-thead-dark {
    background-color: #3f5b60 !important;
  }
  .buttoneval {
    border: 1px solid #2db782;
    color: #2db782;
  }
  .tag-badge {
    display: inline-block;
    padding-right: 1em;
    height: 42px;
    background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
      no-repeat padding-box;
    border-radius: 26px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  
  .dot {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-block;
    /* top: 268px; */
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    padding-top: 9px;
  }
  .orange-icon {
    color: #ff7058;
  }
  
  .orange-icon-badge-align {
    vertical-align: top;
  }
  
  .tag-badge-title {
    text-align: left;
    font: Bold 25px/30px Lato;
    letter-spacing: 0;
    color: #11291b;
    display: inline-block;
  }
  .item-pane {
    justify-content: space-between;
    min-width: 50%;
    box-shadow: -3px 1px 3px #00000029;
    margin-top: 10px;
    display: flex;
    border-bottom: solid 1px #e2e2e2;
  }
  
  .item-pane-info {
    background: #f2f2f2 0% 0% no-repeat padding-box;
    border-radius: 0px 0px 5px 5px;
    margin-bottom: 10px;
    font: 400 14px/17px Lato;
    letter-spacing: 0;
    color: #11291b;
    padding: 20px 10px 10px;
  }
  
  .item-pane-info p {
    margin-bottom: 10px;
  }
  
  .item-pane-info p i {
    margin-right: 8px;
    font-size: 16px;
  }
  .question-box {
    width: 65px;
  
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 22px 12px; */
  }
  .border-box {
    border: 1px solid #e2e2e2;
    border-radius: 5px 5px 0px 0px;
    padding: 20px;
    width: 100%;
  }
  .border-box.gray {
    border-radius: 0px 0px 5px 0px;
    background: #f2f2f2 0% 0% no-repeat padding-box;
    border-top: none;
    padding: 20px 0;
  }
  .border-box.gray.error {
    background: #ffebeb 0% 0% no-repeat padding-box;
    border: 1px solid #c9545e;
  }
  .invalid {
    text-align: left;
    font: Lato, Regular;
    letter-spacing: 0;
    color: #ff5b5c;
    margin-bottom: 5px;
    font-weight: normal;
  }
  i.far.fa-check-circle {
    font-size: 24px;
    padding-right: 4px;
    line-height: 18px;
    margin-left: 4px;
  }
  </style>
  